import { Box, Flex, forwardRef, Icon, ListItem, ListItemProps, Text } from '@chakra-ui/react';

import CheckMarkIcon from '@/assets/icons/ic-check-mark.svg';

interface IComboboxProps extends ListItemProps {
  item: string;
  isSelected: boolean;
}

export const ComboboxItem = forwardRef<IComboboxProps, 'li'>(({ isSelected, item, ...rest }, ref) => {
  return (
    <ListItem
      fontSize="md"
      fontWeight="semibold"
      lineHeight="short"
      transition="background-color 220ms, color 220ms"
      _hover={{
        color: 'violet.400',
        backgroundColor: 'gray.50',
      }}
      px={4}
      py={3}
      cursor="pointer"
      {...rest}
      ref={ref}
    >
      <Flex w="100%" justify="space-between">
        <Text noOfLines={1}>{item}</Text>
        <Box>{isSelected ? <Icon as={CheckMarkIcon} color="violet.400" ml="auto" /> : null}</Box>
      </Flex>
    </ListItem>
  );
});
